import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { isMobile, isTablet } from "react-device-detect";
import Button from '@material-ui/core/Button';

import { ISubCategory } from '../../store/ReminderStore';

interface IProps {
  pageSizeChanged: any;
  pageNoChanged: (pageNo: number) => void;
  items: ISubCategory[];
  paging: any;
  editItemClicked: (item: ISubCategory) => void;
}

const ListItem = ({ pageSizeChanged, pageNoChanged, items, paging, editItemClicked }: IProps) => {

  const onPage = (e: any) => {

    const { page, rows } = e;
    if (Number(paging.PageSize) !== rows) {
      pageSizeChanged(rows);
    }
    else if (Number(paging.PageSize) !== page + 1) {
      pageNoChanged(page + 1);
    }
  };

  const setEdit = (row: ISubCategory) => {
    if (!row.IsSystemManaged) {
      return (
        <span >
          <Button
            type='button'
            onClick={() => editItemClicked(row)}
            variant={isMobile ? "outlined" : "text"} color="primary" style={{ textTransform: 'none' }} >Edit</Button>
        </span>
      );
    }
    return "";
  };


  const setNormalDataTable = () => {
    return (
      <DataTable
        rowHover
        style={{ position: "relative" }}

        //size="small"
        value={items}
        className="p-datatable-gridlines  p-datatable-gridlines-custom p-datatable-sm p-datatable-striped p-datatable-striped-custom"
        resizableColumns columnResizeMode="fit"
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
        scrollable scrollHeight="calc(100vh - 390px)"

      >
        <Column field="Name" header="Name" />
        <Column field="IsSystemManaged" header="Edit" body={(r: ISubCategory) => setEdit(r)} />

      </DataTable>
    );
  };

  const setResponsiveDataTable = () => {
    return (
      <DataTable
        header='Subcategory'
        style={{ position: "relative" }}
        value={items}
        className="p-datatable-responsive p-datatable-sm "
        paginator
        paginatorTemplate="CurrentPageReport  PageLinks  RowsPerPageDropdown"
        currentPageReportTemplate=" {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
      >
        <Column body={(r: ISubCategory) => setResponsiveContents('Name', r.Name)} />
        <Column body={(r: ISubCategory) => setResponsiveContents('Edit', setEdit(r))} />
      </DataTable>
    );
  };


  const setResponsiveContents = (title: string, contents: any, isTitle = true) => {
    return (
      <>
        {isTitle && <span className="p-column-title">{title}</span>}
        <span className="p-column-content">{contents}</span>
      </>
    );
  };


  const setDataTable = () => {
    if (isMobile && !isTablet) {
      return setResponsiveDataTable();
    }
    else {
      return setNormalDataTable();
    }
  };

  return (
    <>
      <div
        className="perfect-scrollbar"
        style={{ position: "relative", width: "100%", height: "100%" }}
      >
        {setDataTable()}
      </div>

    </>
  );


};

export default ListItem;